import classes from './CustomDropdown.module.css';
import { IIdAndLabel } from './ModalDropdown';
import { DefaultTFuncReturn } from 'i18next';

interface Props extends Omit<React.InputHTMLAttributes<HTMLSelectElement>, 'placeholder'> {
  label?: string | DefaultTFuncReturn;
  placeholder?: string | DefaultTFuncReturn;
  options: IIdAndLabel[];
  value?: number | string | undefined;
  onChange: React.ChangeEventHandler<HTMLSelectElement>;
  maxWidth?: string;
  isCalendarSelect?: boolean;
  errorValidation?: boolean;
  disabled?: boolean;
  dropdownStyle?: React.CSSProperties;
  required?: boolean;
  optional?: boolean;
  labelColor?: string;
}

const CustomDropdown: React.FC<Props> = ({
  label,
  placeholder,
  options,
  value,
  onChange,
  maxWidth,
  isCalendarSelect,
  errorValidation,
  disabled,
  dropdownStyle,
  required = false,
  optional,
  labelColor,
  ...props
}) => {
  return (
    <div className={classes.container} style={{ maxWidth: maxWidth ?? '442px' }}>
      <div className={classes.labelContainer}>
        <div className={classes.label} style={labelColor ? { color: `${labelColor}` } : {}}>
          {label}
        </div>
        {optional && <span className={classes.optionalLabel}>(optional)</span>}
        {required && <div className={classes.labelAsterix}>*</div>}
      </div>
      <select
        style={{
          ...dropdownStyle,
        }}
        className={
          !errorValidation
            ? !isCalendarSelect
              ? classes.select
              : classes.calendarSelect
            : classes.errorValidation
        }
        value={value ?? ''}
        onChange={onChange}
        disabled={disabled}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CustomDropdown;
